import downloadBlob from './downloadBlob';

interface DownloadPDFProps {
  blob: Blob;
  filename?: string;
}

const downloadPDF = ({ blob, filename = 'download.pdf' }: DownloadPDFProps) =>
  downloadBlob({ blob, filename });

export default downloadPDF;
